/* eslint @typescript-eslint/no-unused-vars: off */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Slide,
  Slider,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import chroma from "chroma-js";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../../Context/context";
import { ColorTheme } from "../../../../TypesAndConstants/const";
import { THREE_INST } from "../../../SketchUtilities/Three/threeSingleton";
import { ColorContext, ColorContextProvider } from "../ColorContext";
import PaletteMenu from "../ColorSelectSideBar/PaletteMenu";
import ColorPicker from "../ColorSelectSideBar/ColorPicker"
import BlightnessSelecter from '../ColorSelectSideBar/BlightnessSelecter'
import ModeSwitch from '../ModeSwitch'
const useStyles = makeStyles((theme) => ({
  button: {
    margin: "10px",
  },
  stackedSliderContainer: {
    padding: "10px",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "4px 4px 8px",
    margin: "10px 0",
    maxHeight: "80%",
    background: "white",
    borderRadius: "10px",
    border: `2px solid ${ColorTheme.primaryText}`,
  },
  centerContent: {
    display: "flex",
    justifyContent: "center",
  },
  blightnessContent: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px"
  },
  stackedSliderTitle: {
    height: "30px",
  },
  container: {
    fontFamily: "'amatic', cursive",
    position: "absolute",
    right: 0,
    zIndex: 2000,
    padding: "5px",
  },
  mobileContainer: {
    fontFamily: "'amatic', cursive",
    background: "white",
    padding: "10px",
    border: `2px solid ${ColorTheme.primaryText}`,
    boxShadow: "4px 4px 10px",
  },
  buttonContainer: {
    marginTop: "22px",
    display: "flex",
    justifyContent: "space-around",
  },
  paletteContainer: {
    display: "inline-grid",
    margin: "0 auto",
    width: "100%",
  },
  picker: {
    display: "flex",
    margin: "0 auto",
  },
  pickerDisplay: {
    background: "white",
    margin: "0 auto",
  },
  preview: {
    height: "20px",
    width: "100%",
  },
  verticalSlider: {
    marginTop: "50px",
    marginLeft: "-50%",
    transform: "rotate(270deg)",
    mozTransform: "rotate(270deg)",
  },
  dialogMinWidth: {
    minWidth: "60%"
  }
}));

const Transition = React.forwardRef(function Transition(props: any, ref: any) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
  display: string;
}

export default function ColorSideBarModal(props: Props) {
  let three = THREE_INST.getInst();
  const styles = useStyles();
  const {
    state: { brushColor, globalColorData, colorBarIsCollapsed, colorIsAnimated },
    dispatch: mDispatch,
  } = useContext(Context); 
  const {
    state: { colorPalettes },
    dispatch,
  } = useContext(ColorContext);
  const [mouseOnMenu, setIsOnMenu] = useState<boolean>(false);

  // const [isfullScreen, setIsFullScreen ] = useState<boolean>(isSmallScreen)
  const [isAnimated, setAnimated] = useState<boolean>(colorIsAnimated);
  const [shaderColorValue, setShaderColorValue ] = useState("#FFFFFF")

  const setCollapsed = (isCollapsed: boolean) => {
    three.obj.isMobileMenuOpen = false;
    mDispatch({ type: "set_colorbar_collapsed", value: isCollapsed });
  };

  const handleColorSelect = (color: string) => {
    handleModeChange( false )
    mDispatch({ type: "set_brush_color", value: [color] });
  };


  const setRandomColor = () => {
    const randColor = chroma.random().rgb();
    handleVariations(25);
    mDispatch({ type: "set_brush_color", value: [`rgb(${randColor[0]},${randColor[1]},${randColor[2]})`] });
  };

  const handleOpacity = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    event.preventDefault();
    mDispatch({
      type: "set_global_color",
      value: {
        alpha: value,
        darkness: globalColorData.darkness,
        variations: globalColorData.variations,
      },
    });
  };

  const handleBlightness = ( value: number ) => {
    const colorValue = {
        alpha: globalColorData.alpha,
        darkness: value,
        variations: globalColorData.variations,
      };
    mDispatch({
      type: "set_global_color",
      value: colorValue,
    });
  }

  const handleDarkness = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    event.preventDefault();
    const colorValue = {
        alpha: globalColorData.alpha,
        darkness: value,
        variations: globalColorData.variations,
      };
    mDispatch({
      type: "set_global_color",
      value: colorValue,
    });
  };

  const handleModeChange = ( animated: boolean ) => {
    setAnimated( animated )
  }

  const handlePaletteClick = (index: number) => {
    dispatch({ type: "set_palette", value: index });
    mDispatch({ type: "set_brush_color", value: colorPalettes[index] });
  };

  const handleVariations = (variation: number) => {
    mDispatch({
      type: "set_global_color",
      value: {
        alpha: globalColorData.alpha,
        darkness: globalColorData.darkness,
        variations: variation,
      },
    });
  };

  /* eslint react-hooks/exhaustive-deps: off */
  useEffect(() => {
    if ( isAnimated !== colorIsAnimated) {
      mDispatch({ type: "set_color_animated", value: isAnimated });
    }
  }, [isAnimated, colorIsAnimated]);

  return (
    <Dialog
      scroll={"paper"}
      fullScreen={false}
      open={!colorBarIsCollapsed}
      aria-labelledby="form-dialog-title"

      classes={{ paper: styles.dialogMinWidth }}
      style={{
        zIndex: 1000000000,
        display: props.display,
      }}
      TransitionComponent={Transition as any}
    >
      <DialogTitle id="form-dialog-title">Color Select</DialogTitle>
      <DialogContent
        id={"placeholder"}
        className={"colorMobileContainer"}
        style={{
          backgroundColor: "e3e3e3",
          overflowY: "scroll",
        }}
        dividers
      >
        <ColorContextProvider>
          <div className={`${styles.mobileContainer}`} id={"variations"}>
            <ColorPicker className={`${styles.centerContent}`} onColorSet={handleColorSelect}/>
            <BlightnessSelecter className={`${styles.blightnessContent}`}
                                onChange={handleBlightness}/>
            <>
              <div
                id={"colorPickerMobile"}
                style={{ marginTop: "15px", backgroundColor: "white" }}
              ></div>

              <div
                style={{
                  minHeight: "250px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  padding: "10px",
                }}
              >
                <div className={styles.stackedSliderContainer}>
                  <div>
                    <p
                      style={{
                        fontFamily: "amatic",
                        fontSize: "2rem",
                        margin: "0",
                      }}
                    >
                      Opacity:
                    </p>
                    <Slider
                      defaultValue={globalColorData.alpha}
                      aria-labelledby="discrete-slider-small-steps"
                      onChange={handleOpacity}
                      min={0.1}
                      max={1}
                      step={0.1}
                      value={globalColorData.alpha}
                    />
                  </div>
                </div>
                <div className={styles.centerContent}>
                <ModeSwitch onModeChange={handleModeChange} defaultValue={colorIsAnimated} offMenuLabel={"Solid"} onMenuLabel={"Animated"}/>
                </div>
                <Divider style={{ marginTop: "15px" }} />
                <div style={{ display: isAnimated ? "block" : "none" }}>
                  <PaletteMenu
                    palettes={colorPalettes}
                    setVariations={handleVariations}
                    variations={globalColorData.variations}
                    setRandomColor={setRandomColor}
                    handlePaletteClick={handlePaletteClick}
                  />
                </div>
              </div>
              <Divider style={{ marginTop: "15px" }} />
            </>
          </div>
        </ColorContextProvider>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setCollapsed(true);
          }}
          variant="contained"
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
